import { useState, useEffect } from "react";
import cn from "classnames";
import {
  useGetTeamMemberSummary,
  useGetTeamMemberSkills,
  useGetMyTeams,
  useGetTeamMemberValueDelivered,
  getRatingColor,
} from "@/service/team-assessment";
import { SkillsMatrixTable, SummarySection } from "@/pages/assessment/_components";
import { BackButton, Loader } from "@/shared/ui";
import { TeamMemberSelector } from "./_components";

export const TeamResultsPage = () => {
  const [selectedMemberFmno, setSelectedMemberFmno] = useState<string>();

  const { data: myTeams, isLoading: isLoadingTeams } = useGetMyTeams();
  const teamData = myTeams?.[0];

  // const members = useMemo(() => teamData?.members?.filter((member) => member.bucket !== null), [teamData?.members]);
  const members = teamData?.members;

  const { data: summary, isLoading: isLoadingSummary } = useGetTeamMemberSummary(teamData?.team_id, selectedMemberFmno);
  const { data: skills, isLoading: isLoadingSkills } = useGetTeamMemberSkills(teamData?.team_id, selectedMemberFmno);
  const { data: valueDelivered, isLoading: isLoadingValueDelivered } = useGetTeamMemberValueDelivered(
    teamData?.team_id,
    selectedMemberFmno,
  );
  useEffect(() => {
    if (members?.length && !selectedMemberFmno) {
      setSelectedMemberFmno(members[0].fmno);
    }
  }, [members, selectedMemberFmno]);

  const selectedMember = members?.find((m) => m.fmno === selectedMemberFmno);

  if (isLoadingTeams) {
    return (
      <div className="container-wrapper flex w-full flex-col">
        <BackButton />
        <div className="mt-20 flex w-full items-center justify-center">
          <Loader />
        </div>
      </div>
    );
  }

  return (
    <div className="container-wrapper flex w-full flex-col">
      <BackButton />
      <h1 className="font-family-third text-eerie-black mt-6 text-[40px]/[120%] font-bold">
        Performance Review / Team Results
      </h1>
      <div className="mt-6 rounded-4xl bg-white p-8 shadow-[0_0_32px_-8px_rgba(165,44,161,0.12)]">
        {members?.length ? (
          <>
            <div className="mb-6 flex gap-2">
              <TeamMemberSelector
                teamMembers={members}
                selectedMember={selectedMember}
                onSelectMember={(member) => setSelectedMemberFmno(member.fmno)}
              />
            </div>
            {(isLoadingSummary || isLoadingSkills || isLoadingValueDelivered) && (
              <div className="flex w-full items-center justify-center">
                <Loader />
              </div>
            )}
            {summary && skills && (
              <>
                <div className="mb-8 flex flex-col justify-between md:flex-row">
                  <h2 className="font-family-third text-2xl font-semibold">
                    Final Rating {summary?.periods[0]?.period_label}:
                    <span className={cn("pl-2", getRatingColor(summary?.periods[0]?.overall_rating || ""))}>
                      {summary?.periods[0]?.overall_rating}
                    </span>
                  </h2>
                </div>
                <SummarySection summary={summary.periods[0]} skills={skills.periods[0]} />
                <div className="mt-6">
                  <SkillsMatrixTable skills={skills.periods[0]} valueDelivered={valueDelivered} />
                </div>
              </>
            )}
          </>
        ) : (
          <p className="text-center text-gray-500">No teams available</p>
        )}
      </div>
    </div>
  );
};
